import { FC, memo } from 'react'
import { Button } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'
import Tooltip from '@mui/material/Tooltip'

const AddImageButton: FC = () => {
  const { filePickerRef, saving } = usePdfEditor()
  const handleAddImageClicked = useCallbackDebounced(() => {
    filePickerRef.current?.click()
  }, [filePickerRef])
  return (
    <Tooltip title={'Add image'} placement="bottom">
      <Button intent="none" icon="media" onClick={handleAddImageClicked} disabled={saving} />
    </Tooltip>
  )
}

export default memo(AddImageButton)
